import axios from 'axios';

export default {
    methods: {
        async formaPagoSelect(ok, err) {
            try {
                let r = await axios.post('forma-pago/select');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/forma_pago.js